import IconChess from './chess.png'
import IconChessChecked from './chess-checked.png'
import IconSetting from './setting.png'
import IconSettingChecked from './setting-checked.png'
import IconRight from './right.png'
import IconRadioDefault from './radio-default.png'
import IconRadioChecked from './radio-checked.png'
import IconCamere from './camere.png'
import IconSwitch from './switch.png'
import IconDividerWhite from './divider-white.png'
import IconDropWhite from './drop-white.png'
import IconSmile from './smile.png'
import IconNotice from './notice.png'
import IconEdit from './edit.png'
import IconGrade13 from './grade13.png'
import IconGrade14 from './grade14.png'
import IconGrade15 from './grade15.png'
import IconGrade16 from './grade16.png'
import IconCopy from './copy.png'
import IconSuccess from './success.png'
import IconPending from './pending.png'
import IconPending2 from './pending2.png'
import IconEnding from './ending.png'
import IconBack from './back.png'
import IconPlus from './plus.png'
import IconEyeShow from './eye-show.png'
import IconEyeHide from './eye-hide.png'
import IconLock from './lock.png'

const icons: { [key: string]: string } = {
  IconChess,
  IconChessChecked,
  IconSetting,
  IconSettingChecked,
  IconRight,
  IconRadioDefault,
  IconRadioChecked,
  IconCamere,
  IconSwitch,
  IconDividerWhite,
  IconDropWhite,
  IconSmile,
  IconNotice,
  IconEdit,
  IconGrade13,
  IconGrade14,
  IconGrade15,
  IconGrade16,
  IconCopy,
  IconSuccess,
  IconPending,
  IconPending2,
  IconEnding,
  IconBack,
  IconPlus,
  IconEyeShow,
  IconEyeHide,
  IconLock,
}

export default icons
